module.exports = __webpack_public_path__ + "img/i06.8bceb994.svg";